<template>
  <Flex direction="column">
    <BaseCard gray>
      <Flex direction="column">
        <AutoInvoiceSettings />
        <BaseCheckbox
          v-model="formData.settings.sales.showTreatmentDateOnInvoice"
          :label="
            $t('admin.invoices.permissions.show_treatment_date')
          "
          v-test="'showTreatmentDateOnInvoice'"
        />
        <BaseCheckbox
          v-model="formData.settings.sales.paymentLink"
          :disabled="!hasPaymentLink"
          :label="$t('admin.invoices.permissions.payment_link')"
          v-test="'paymentLink'"
        />
        <BaseAlert
          v-if="!hasPaymentProvider"
          :text="$t('admin.invoices.permissions.payment_link_alert')"
          color="warning"
          :primaryAction="{
            text: $t('nav.integrations'),
            routerLink: {
              name: 'integrations'
            }
          }"
          v-test="'payment-provider-alert'"
        />
      </Flex>
    </BaseCard>
    <BaseCard gray>
      <Flex direction="column">
        <LogoDescription />
        <ImageUpload />
      </Flex>
    </BaseCard>
    <BaseCard gray>
      <Flex direction="column">
        <BaseInput
          v-model="formData.invoiceHeader"
          type="textarea"
          :info="$t('admin.invoices.content.header_description')"
          :label="$t('admin.invoices.content.header_title')"
          v-test="'invoiceHeader'"
        />
        <BaseInput
          v-model="formData.invoiceRecipientTemplate"
          type="textarea"
          :label="
            $t('admin.invoices.content.customer_information_title')
          "
          v-test="'invoiceRecipientTemplate'"
        />
        <BaseInput
          v-model="formData.invoiceFooter"
          type="textarea"
          :label="$t('admin.invoices.content.footer_title')"
          v-test="'invoiceFooter'"
        />
        <BaseText @click="showVariablesModal = true">
          {{ $t('admin.invoices.content.help_link') }}
        </BaseText>
      </Flex>
    </BaseCard>
  </Flex>
</template>

<script
  lang="ts"
  setup
>
import { inject, type Ref } from 'vue';
import AutoInvoiceSettings from './AutoInvoiceSettings.vue';
import ImageUpload from './ImageUpload.vue';
import LogoDescription from './LogoDescription.vue';
import type { InvoiceFormData } from './useInvoices';

const showVariablesModal = inject<Ref<boolean>>('showVariablesModal')!;
const formData = inject<InvoiceFormData>('formData')!;
const hasPaymentProvider = inject<Ref<boolean>>('hasPaymentProvider');
const hasPaymentLink = inject<Ref<boolean>>('hasPaymentLink');
</script>
